import { ComponentType } from '../../../ui/shared/enums/ComponentType';
import { Context } from '../../../ui/shared/enums/Context';
import { FontWeight } from '../../../ui/shared/enums/FontWeight';
import type { DestinationItemArchetype } from '../../../ui/archetypes/DestinationItemArchetype';
import {
  defaultBaseDestination,
  defaultBaseSkin,
  placeholderBaseDestination,
  placeholderBaseSkin,
} from './BaseDestinationDefaults';

export const defaultDestinationItemArchetype: Partial<DestinationItemArchetype> =
  {
    id: 0,
    ...(defaultBaseDestination),
    ...(defaultBaseSkin),
    isDisabled: false,
    context: Context.None,
    componentType: ComponentType.Internal,
  };

export const placeholderDestinationItemArchetype: Partial<DestinationItemArchetype> =
  {
    id: 1,
    ...(placeholderBaseDestination),
    ...(placeholderBaseSkin),
    fontWeight: FontWeight.Normal,
    componentType: ComponentType.Internal,
  };
